export enum PickerTypes {
  ShelfType = 'shelf-type',
  ShelfColor = 'shelf-color',
  Item = 'item',
}
